<template>
  <div  class="DwhxpAndYwslTjHome">
    <div class="contentCss" style="float: left;width:300px;">
      <el-tree
        style="margin-top:20px;"
        lazy
        check-strictly
        ref="xzqhTree"
        show-checkbox
        node-key="value"
        :default-expanded-keys="[activeNodeId]"
        :default-checked-keys="[activeNodeId]"
        :props="props"
        :load="loadNode"
        check-on-click-node
        @check-change="handleCheckChange"
      >
      </el-tree>
    </div>
    <div class="contentCss" style="display: inline-block;width: calc(100% - 340px);">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="formInline"
            label-position="left"
            label-width="90px"
          >
            <el-form-item label="单位名称:">
              <el-input  v-model="formInline.dwmc" filterable placeholder="精确查询，请输入" />
            </el-form-item>
            <el-form-item label="预警日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="formInline.beginYjsj"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                />
              </el-col>
              <el-col style="text-align: center" class="line" :span="3">-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="formInline.endYjsj"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                />
              </el-col>
            </el-form-item>
            <div>
              <el-button
                type="primary"
                icon="el-icon-search"
                round
                size="small"
                @click="handleCurrentChange(1)"
              >搜索</el-button>
              <el-button
                icon="el-icon-refresh-left"
                round
                size="small"
                @click="resetDataSource"
              >重置</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div
        style="margin: auto;
        max-width: 1518px;
        background-color: white;
        padding: 0px 20px 57px;"
      >
        <div class="tablemes">
          <div
            style="
            background-color: #f2f2f2;
            padding: 10px;
            border: 1px solid #f2f2f2;
          "
          >
            <el-button
              v-preventReClick
              icon="el-icon-upload2"
              size="mini"
              @click="dcExcel"
            >导出</el-button>
            <el-tag type="danger">无默认查询，行政区划(非全国)、单位名称、时间至少存在一个条件</el-tag>
          </div>
          <el-table
            ref="xqkczlTabel"
            :data="tableData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              min-width="200px"
              prop="yjdwMc"
              label="单位名称"
            />
            <el-table-column
              min-width="160px"
              prop="xzqh"
              label="行政区划"
            />
            <el-table-column
              min-width="200px"
              prop="yjnrStr"
              label="预警内容"
            />
            <el-table-column
              prop="ztStr"
              label="状态"
            />
            <el-table-column
              min-width="80px"
              prop="czjgStr"
              label="处置结果"
            />
            <el-table-column
              min-width="120px"
              prop="yjsj"
              label="预警时间"
            />
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getSysYjxxList, exportSysYjxxList} from "@/assets/js/system";
  import {getXzqTree, getXzqTreeS} from "@/assets/js/SplcPzym";

export default {
  name:'DwhxpAndYwslTj',
  data(){
    return {
      props: {
        label: "label",
        key: "value",
        isLeaf: (data, node) => {
          return !data.leaf;
        },
      },
      activeNodeId: 0, //当前选中区域Id
      activeLevel: "-1", //当前选中区域level
      formInline: { // 搜索表单
        dwmc: '',
        beginYjsj: '',
        endYjsj: ''
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 列表总数
      tableData: [], // 表格数据
    }
  },
  mounted() {
  },
  methods:{
    loadNode(node, resolve) {
      if (node.level == 0) {
        getXzqTree().then((res) => {
          resolve([res.data.data]);
        });
      }
      if (node.level > 0) {
        if (node.data.isReq) {
          getXzqTreeS(node.data.value).then((res) => {
            resolve(res.data.data);
          });
        } else {
          return resolve(node.data.children);
        }
        return resolve([]); // 加上这个，防止在该节点没有子节点时一直转圈的问题发生。
      }
    },
    handleCheckChange(data, checked, node) {
      if (checked) {
        //实现单选功能
        this.activeNodeId = data.value;
        this.activeLevel = data.level;
        this.$refs.xzqhTree.setCheckedKeys([]);
        this.$refs.xzqhTree.setCheckedKeys([data.value]);
      }
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        dwmc: '',
        beginYjsj: '',
        endYjsj: ''
      }
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadDatasource()
    },
    // 查询列表数据
    loadDatasource() {
      this.formInline.xzqhId = this.activeNodeId
      this.formInline.level = this.activeLevel
      getSysYjxxList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.formInline
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    //导出
    dcExcel() {
      this.formInline.xzqhId = this.activeNodeId
      this.formInline.level = this.activeLevel
      this.$message.info("正在导出中...")
      exportSysYjxxList({param: this.formInline})
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '预警信息详情'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
  }
}
</script>

<style scoped lang='less'>
  .DwhxpAndYwslTjHome {
    // height: 100%;
    // width: 90%;
    // background-color: white;
    // margin: auto;
    .contentCss{
      height:825px;
      background-color: white;
      margin: 20px 20px 0px 0px;
      overflow-y: auto;
    }
    .headerSearch {
      max-width: 1518px;
      margin: auto;
      margin-bottom: 11px;
      padding: 20px;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .sousuo {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: space-between;
      }
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
    .tablemes {
      margin: auto;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
